import React, { useState } from 'react';

import { TextField, Button, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  button: {
    height: '100%',
  },
});

export const ClipboardCopyInput = ({ text }: { text: string }) => {
  const [isCopied, setIsCopied] = useState(false);

  const classes = useStyles();

  const handleCopyClick = async () => {
    try {
      if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(text);
      } else {
        document.execCommand('copy', true, text);
      }
      setIsCopied(true);
    } catch (error) {
      setIsCopied(false);
    }
  };

  return (
    <Grid container spacing={0}>
      <Grid item xs={10}>
        <TextField
          id="text"
          variant="outlined"
          size="small"
          fullWidth
          value={text}
          InputProps={{ readOnly: true }}
        />
      </Grid>

      <Grid item xs={2}>
        <Button
          className={classes.button}
          variant="contained"
          onClick={handleCopyClick}
        >
          {isCopied ? 'Copied' : 'Copy'}
        </Button>
      </Grid>
    </Grid>
  );
};
